export enum Strategy {
  JWT = 'jwt',
  LOCAL = 'local',
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
}
